<div class="bmc-connect-virtualization-detail__list" *ngIf="virtualEntities.length > 0">
  <div class="bmc-connect-virtualization-detail__title">{{'PROVIDERS.VIRTUALIZATION.ENTITIES' | translate}}</div>
  <ul>
    <li class="bmc-connect-virtualization-detail__item" *ngFor="let virtualEntity of virtualEntities">{{virtualEntity.displayName}}</li>
  </ul>
</div>

<div class="bmc-connect-virtualization-detail__list" *ngIf="virtualEntities.length === 0">
  <div class="bmc-connect-virtualization-detail__without-selection">
    <img class="bmc-connect-virtualization-detail__image bmc-connect-virtualization-detail__block" src="assets/img/bg-no-item-selected.png" alt="Virtual entity"/>
    <div class="bmc-connect-virtualization-detail__title-image bmc-connect-virtualization-detail__block">{{'PROVIDERS.VIRTUALIZATION.WITHOUT_ENTITY' | translate}}</div>
  </div>
</div>
